// TurnierBearbeitenPage.jsx — Komplett neu
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../styles/TurnierBearbeitenPage.css';
import RabattcodeTab   from './RabattcodeTab';
import DivisionenTab   from './DivisionenTab';

const DISZIPLINEN = [
  "Traditionelle Formen", "Waffenformen", "Musikformen", "Creativformen",
  "Grappling", "Rumble", "Pointfighting", "Continous Fighting",
  "Fullcontact", "K1", "Kumite", "Bruchtest Traditionell",
  "Bruchtest Creative", "1/1 Selbstverteidigung", "Team Selbstverteidigung", "Real Self Defense",
];

const KATEGORIEN = [
  { id: 'Kumite',           label: 'Kumite',              icon: '🥊' },
  { id: 'Formen',           label: 'Formen / Kata',        icon: '🎭' },
  { id: 'Formen Waffen',    label: 'Formen Waffen',        icon: '🗡️' },
  { id: 'Kickboxen',        label: 'Kickboxen',            icon: '🦵' },
  { id: 'K1',               label: 'K1',                   icon: '🥊' },
  { id: 'Selbstverteidigung', label: 'Selbstverteidigung', icon: '🛡️' },
  { id: 'Grappling',        label: 'Grappling',            icon: '🤼' },
  { id: 'Rumble',           label: 'Rumble',               icon: '⚔️' },
  { id: 'Bruchtest',        label: 'Bruchtest',            icon: '🧱' },
  { id: 'BJJ',              label: 'Brazilian Jiu-Jitsu',  icon: '🥋' },
];

const TOURNAMENT_MODES = [
  { value: 'single_elimination',              label: 'Single Elimination (KO)',    description: 'Verloren = Raus' },
  { value: 'single_elimination_bronze',       label: 'KO + Bronze-Kampf',          description: 'Mit Kampf um Platz 3' },
  { value: 'single_elimination_double_bronze',label: 'KO + Doppel-Bronze',         description: 'Beide Halbfinal-Verlierer = Platz 3' },
  { value: 'consolation_bracket',             label: 'Trostrunden-Bracket',        description: 'Verlierer kämpfen separat' },
  { value: 'double_elimination',              label: 'Double Elimination',         description: '2x verlieren = raus' },
  { value: 'repechage',                       label: 'Repechage (Olympisch)',       description: 'Trostrunde für Verlierer gegen Finalisten' },
  { value: 'round_robin',                     label: 'Round Robin',                description: 'Jeder gegen Jeden' },
];

const FORMEN_MODES = [
  { value: 'average',               label: 'Durchschnitt',           description: 'Aller Kampfrichter-Wertungen' },
  { value: 'average_drop_extremes', label: 'Durchschnitt (ohne Ext.)',description: 'Höchste & niedrigste gestrichen' },
  { value: 'total',                 label: 'Summe',                  description: 'Alle Punkte addiert' },
  { value: 'majority',              label: 'Mehrheitsentscheidung',   description: 'Kampfrichter stimmen für Platzierung' },
];

const BRUCHTEST_MODES = [
  { value: 'pass_fail',  label: 'Bestanden / Nicht bestanden', description: 'Einfache Ja/Nein Bewertung' },
  { value: 'points',     label: 'Punktesystem',                description: 'Punkte nach Schwierigkeitsgrad' },
  { value: 'count',      label: 'Anzahl Bretter',              description: 'Wer mehr bricht, gewinnt' },
  { value: 'technique',  label: 'Technik + Kraft',             description: 'Kombinierte Wertung' },
];

const SV_MODES = [
  { value: 'points_total', label: 'Gesamtpunkte',         description: 'Summe aller Technik-Bewertungen' },
  { value: 'average',      label: 'Durchschnitt',         description: 'Durchschnitt der Kampfrichter' },
  { value: 'criteria',     label: 'Kriterienbewertung',   description: 'Effektivität, Technik, Präsentation' },
  { value: 'ranking',      label: 'Direktes Ranking',     description: 'Kampfrichter vergeben Platzierungen' },
];

const TABS = [
  { id: 'grunddaten',   label: 'Grunddaten',   icon: '📋' },
  { id: 'termin',       label: 'Termin & Ort', icon: '📍' },
  { id: 'preise',       label: 'Preise',       icon: '💰' },
  { id: 'codes',        label: 'Codes',        icon: '🏷️' },
  { id: 'divisionen',   label: 'Divisionen',   icon: '🏅' },
  { id: 'einstellungen',label: 'Einstellungen',icon: '⚙️' },
  { id: 'medien',       label: 'Logo & Plakat', icon: '🖼️' },
  { id: 'kontakt',      label: 'Kontakt',      icon: '📞' },
];

const STATUS_OPTIONS = ['Geplant', 'Aktiv', 'Abgeschlossen', 'Abgesagt'];

export default function TurnierBearbeitenPage() {
  const navigate  = useNavigate();
  const location  = useLocation();

  const extractId = () => {
    const parts = location.pathname.split('/');
    const idx   = parts.findIndex(p => p === 'turnier-bearbeiten');
    return idx !== -1 && parts[idx + 1] ? parts[idx + 1] : null;
  };

  const id           = extractId();
  const isNew        = !id || id === 'neu';
  const initialData  = location.state?.turnier || null;

  const [activeTab, setActiveTab]               = useState('grunddaten');
  const [loading, setLoading]                   = useState(!isNew && !initialData);
  const [saving, setSaving]                     = useState(false);
  const [error, setError]                       = useState('');
  const [success, setSuccess]                   = useState('');
  const [selectedKategorien, setSelectedKategorien] = useState([]);
  const [logoPreview,   setLogoPreview]   = useState(null);
  const [plakatPreview, setPlakatPreview] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [logoFile,      setLogoFile]      = useState(null);
  const [plakatFile,    setPlakatFile]    = useState(null);
  const [bannerFile,    setBannerFile]    = useState(null);
  const [discountMode,  setDiscountMode]  = useState('percent'); // 'percent' | 'euro'
  // Frühbucher-Perioden
  const [perioden, setPerioden]           = useState([]);
  const [periodenOrig, setPeriodenOrig]   = useState([]); // zum Diff beim Speichern

  const [form, setForm] = useState({
    name:                     initialData?.name || '',
    beschreibung:             initialData?.beschreibung || '',
    sportart:                 initialData?.sportart || '',
    disziplin:                initialData?.disziplin || '',
    start_datum:              initialData?.start_datum?.split('T')[0] || initialData?.datum?.split('T')[0] || '',
    datum_text:               initialData?.datum_text || '',
    end_datum:                initialData?.end_datum?.split('T')[0] || '',
    anmeldeschluss:           initialData?.anmeldeschluss?.split('T')[0] || '',
    max_teilnehmer:           initialData?.max_teilnehmer || '',
    anmeldegebuehr:           initialData?.anmeldegebuehr || '',
    ort:                      initialData?.ort || '',
    adresse:                  initialData?.adresse || '',
    plz:                      initialData?.plz || '',
    stadt:                    initialData?.stadt || '',
    land:                     initialData?.land || 'Deutschland',
    kontakt_email:            initialData?.kontakt_email || '',
    kontakt_telefon:          initialData?.kontakt_telefon || '',
    website:                  initialData?.website || '',
    regeln:                   initialData?.regeln || '',
    hinweise:                 initialData?.hinweise || '',
    status:                   initialData?.status || 'Geplant',
    veroeffentlicht:          initialData?.veroeffentlicht || false,
    altersklassen:            initialData?.altersklassen || '',
    gewichtsklassen:          initialData?.gewichtsklassen || '',
    default_tournament_mode:  initialData?.default_tournament_mode || 'single_elimination_bronze',
    formen_scoring_mode:      initialData?.formen_scoring_mode || 'average_drop_extremes',
    bruchtest_scoring_mode:   initialData?.bruchtest_scoring_mode || 'points',
    sv_scoring_mode:          initialData?.sv_scoring_mode || 'criteria',
    preis_einzel:             initialData?.preis_einzel ?? 25.00,
    preis_team:               initialData?.preis_team ?? 40.00,
    rabatt_zweite_kategorie:  initialData?.rabatt_zweite_kategorie ?? 20,
    rabatt_weitere_kategorien:initialData?.rabatt_weitere_kategorien ?? 40,
    fruehbucher_bis:          initialData?.fruehbucher_bis?.split('T')[0] || '',
    fruehbucher_rabatt:       initialData?.fruehbucher_rabatt ?? 0,
    nachmeldegebuehr:         initialData?.nachmeldegebuehr ?? 0,
    nachmeldung_von_datum:    initialData?.nachmeldung_von_datum?.split('T')[0] || '',
    nachmeldung_von_uhrzeit:  initialData?.nachmeldung_von_uhrzeit?.slice(0, 5) || '',
    nachmeldung_bis_datum:    initialData?.nachmeldung_bis_datum?.split('T')[0] || '',
    nachmeldung_bis_uhrzeit:  initialData?.nachmeldung_bis_uhrzeit?.slice(0, 5) || '',
    bank_kontoinhaber:        initialData?.bank_kontoinhaber || '',
    bank_iban:                initialData?.bank_iban || '',
    bank_bic:                 initialData?.bank_bic || '',
    bank_name:                initialData?.bank_name || '',
    bank_verwendungszweck:    initialData?.bank_verwendungszweck || '',
    altersberechnung_stichtag:initialData?.altersberechnung_stichtag || 'turniertag',
    altersberechnung_datum:   initialData?.altersberechnung_datum?.split('T')[0] || '',
    anmeldung_gewicht_pflicht:        !!initialData?.anmeldung_gewicht_pflicht,
    anmeldung_graduierung_pflicht:    !!initialData?.anmeldung_graduierung_pflicht,
    min_graduierung:          initialData?.min_graduierung || '',
    max_teilnehmer_division:  initialData?.max_teilnehmer_division || '',
  });

  const token      = localStorage.getItem('token');
  const authHeader = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };

  useEffect(() => {
    if (!isNew) fetchTurnier();
    if (!isNew && id) { fetchKategorien(); fetchPerioden(); }
  }, [id]); // eslint-disable-line

  const fetchTurnier = async () => {
    try {
      const res    = await fetch(`/api/turniere/${id}`, { headers: authHeader });
      if (!res.ok) throw new Error('Turnier konnte nicht geladen werden');
      const result = await res.json();
      const t      = result.data || result;
      setForm({
        name:                     t.name || '',
        beschreibung:             t.beschreibung || '',
        sportart:                 t.sportart || '',
        disziplin:                t.disziplin || '',
        start_datum:              t.start_datum?.split('T')[0] || t.datum?.split('T')[0] || '',
        datum_text:               t.datum_text || '',
        end_datum:                t.end_datum?.split('T')[0] || '',
        anmeldeschluss:           t.anmeldeschluss?.split('T')[0] || '',
        max_teilnehmer:           t.max_teilnehmer || '',
        anmeldegebuehr:           t.anmeldegebuehr || '',
        ort:                      t.ort || '',
        adresse:                  t.adresse || '',
        plz:                      t.plz || '',
        stadt:                    t.stadt || '',
        land:                     t.land || 'Deutschland',
        kontakt_email:            t.kontakt_email || '',
        kontakt_telefon:          t.kontakt_telefon || '',
        website:                  t.website || '',
        regeln:                   t.regeln || '',
        hinweise:                 t.hinweise || '',
        status:                   t.status || 'Geplant',
        veroeffentlicht:          !!t.veroeffentlicht,
        altersklassen:            t.altersklassen || '',
        gewichtsklassen:          t.gewichtsklassen || '',
        default_tournament_mode:  t.default_tournament_mode || 'single_elimination_bronze',
        formen_scoring_mode:      t.formen_scoring_mode || 'average_drop_extremes',
        bruchtest_scoring_mode:   t.bruchtest_scoring_mode || 'points',
        sv_scoring_mode:          t.sv_scoring_mode || 'criteria',
        preis_einzel:             t.preis_einzel ?? 25,
        preis_team:               t.preis_team ?? 40,
        rabatt_zweite_kategorie:  t.rabatt_zweite_kategorie ?? 20,
        rabatt_weitere_kategorien:t.rabatt_weitere_kategorien ?? 40,
        fruehbucher_bis:          t.fruehbucher_bis?.split('T')[0] || '',
        fruehbucher_rabatt:       t.fruehbucher_rabatt ?? 0,
        nachmeldegebuehr:         t.nachmeldegebuehr ?? 0,
        nachmeldung_von_datum:    t.nachmeldung_von_datum?.split('T')[0] || '',
        nachmeldung_von_uhrzeit:  t.nachmeldung_von_uhrzeit?.slice(0, 5) || '',
        nachmeldung_bis_datum:    t.nachmeldung_bis_datum?.split('T')[0] || '',
        nachmeldung_bis_uhrzeit:  t.nachmeldung_bis_uhrzeit?.slice(0, 5) || '',
        bank_kontoinhaber:        t.bank_kontoinhaber || '',
        bank_iban:                t.bank_iban || '',
        bank_bic:                 t.bank_bic || '',
        bank_name:                t.bank_name || '',
        bank_verwendungszweck:    t.bank_verwendungszweck || '',
        altersberechnung_stichtag:t.altersberechnung_stichtag || 'turniertag',
        altersberechnung_datum:   t.altersberechnung_datum?.split('T')[0] || '',
        anmeldung_gewicht_pflicht:        !!t.anmeldung_gewicht_pflicht,
        anmeldung_graduierung_pflicht:    !!t.anmeldung_graduierung_pflicht,
        min_graduierung:          t.min_graduierung || '',
        max_teilnehmer_division:  t.max_teilnehmer_division || '',
      });
      if (t.logo_url)   setLogoPreview(t.logo_url);
      if (t.plakat_url) setPlakatPreview(t.plakat_url);
      if (t.banner_url) setBannerPreview(t.banner_url);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchKategorien = async () => {
    try {
      const res  = await fetch(`/api/turniere/${id}/kategorien`, { headers: authHeader });
      if (res.ok) {
        const d = await res.json();
        setSelectedKategorien(d.data || []);
      }
    } catch (e) { console.error(e); }
  };

  const fetchPerioden = async () => {
    try {
      const res = await fetch(`/api/turniere/${id}/fruehbucher`, { headers: authHeader });
      if (res.ok) {
        const d = await res.json();
        const rows = (d.data || []).map(p => ({ ...p, _key: p.id }));
        setPerioden(rows);
        setPeriodenOrig(rows.map(r => r.id));
      }
    } catch (e) { console.error(e); }
  };

  // Perioden-Helfer
  const addPeriode = () => setPerioden(ps => [
    ...ps,
    { _key: Date.now(), id: null, bezeichnung: '', von_datum: '', von_uhrzeit: '00:00', bis_datum: '', bis_uhrzeit: '23:59', rabatt_prozent: '' }
  ]);
  const removePeriode = (key) => setPerioden(ps => ps.filter(p => p._key !== key));
  const updatePeriode = (key, field, val) =>
    setPerioden(ps => ps.map(p => p._key === key ? { ...p, [field]: val } : p));

  const syncPerioden = async (turnierId) => {
    const currentIds = new Set(perioden.filter(p => p.id).map(p => p.id));
    // Löschen: IDs die nicht mehr vorhanden
    for (const origId of periodenOrig) {
      if (!currentIds.has(origId)) {
        await fetch(`/api/turniere/${turnierId}/fruehbucher/${origId}`, { method: 'DELETE', headers: authHeader });
      }
    }
    // Erstellen oder Aktualisieren
    for (const p of perioden) {
      if (!p.von_datum || !p.bis_datum || !p.rabatt_prozent) continue;
      const body = JSON.stringify({
        bezeichnung:    p.bezeichnung || null,
        von_datum:      p.von_datum,
        von_uhrzeit:    p.von_uhrzeit || '00:00:00',
        bis_datum:      p.bis_datum,
        bis_uhrzeit:    p.bis_uhrzeit || '23:59:59',
        rabatt_prozent: parseFloat(p.rabatt_prozent),
        sort_order:     0,
      });
      if (p.id) {
        await fetch(`/api/turniere/${turnierId}/fruehbucher/${p.id}`, { method: 'PUT', headers: authHeader, body });
      } else {
        await fetch(`/api/turniere/${turnierId}/fruehbucher`, { method: 'POST', headers: authHeader, body });
      }
    }
  };

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  // Disziplinen helpers
  const disziplinList  = form.disziplin ? form.disziplin.split(',').map(s => s.trim()).filter(Boolean) : [];
  const allDisziplinen = disziplinList.length === DISZIPLINEN.length;

  const toggleDisziplin = (disc) => {
    const updated = disziplinList.includes(disc)
      ? disziplinList.filter(d => d !== disc)
      : [...disziplinList, disc];
    set('disziplin', updated.join(', '));
  };

  const selectAllDisziplinen = () =>
    set('disziplin', allDisziplinen ? '' : DISZIPLINEN.join(', '));

  const toggleKategorie = (katId) =>
    setSelectedKategorien(prev =>
      prev.includes(katId) ? prev.filter(k => k !== katId) : [...prev, katId]
    );

  const handleFileChange = (type, file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = e => {
      if (type === 'logo')   { setLogoPreview(e.target.result);   setLogoFile(file); }
      if (type === 'plakat') { setPlakatPreview(e.target.result); setPlakatFile(file); }
      if (type === 'banner') { setBannerPreview(e.target.result); setBannerFile(file); }
    };
    reader.readAsDataURL(file);
  };

  const uploadSingle = async (turnierId, file, type) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('type', type);
    const res = await fetch(`/api/turniere/${turnierId}/upload`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: fd
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `${type}-Upload fehlgeschlagen (${res.status})`);
    }
    return res.json();
  };

  const uploadFiles = async (turnierId) => {
    if (!turnierId) return;
    const errors = [];
    if (logoFile) {
      try {
        const data = await uploadSingle(turnierId, logoFile, 'logo');
        if (data.url) { setLogoPreview(data.url); setLogoFile(null); }
      } catch (e) { errors.push(e.message); }
    }
    if (plakatFile) {
      try {
        const data = await uploadSingle(turnierId, plakatFile, 'plakat');
        if (data.url) { setPlakatPreview(data.url); setPlakatFile(null); }
      } catch (e) { errors.push(e.message); }
    }
    if (bannerFile) {
      try {
        const data = await uploadSingle(turnierId, bannerFile, 'banner');
        if (data.url) { setBannerPreview(data.url); setBannerFile(null); }
      } catch (e) { errors.push(e.message); }
    }
    if (errors.length) throw new Error(errors.join(' | '));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim())     { setError('Bitte Turniernamen eingeben.');  setActiveTab('grunddaten'); return; }
    if (!form.start_datum && !form.datum_text) { setError('Bitte Startdatum oder Datumshinweis eingeben.'); setActiveTab('termin'); return; }

    setSaving(true);
    setError('');
    setSuccess('');

    try {
      const url    = isNew ? '/api/turniere' : `/api/turniere/${id}`;
      const method = isNew ? 'POST' : 'PUT';

      const payload = {
        name:                     form.name,
        beschreibung:             form.beschreibung,
        sportart:                 form.sportart,
        start_datum:              form.start_datum || null,
        datum_text:               form.datum_text || null,
        end_datum:                form.end_datum || form.start_datum || null,
        ort:                      form.ort,
        adresse:                  form.adresse,
        plz:                      form.plz,
        stadt:                    form.stadt,
        land:                     form.land,
        disziplin:                form.disziplin,
        anmeldeschluss:           form.anmeldeschluss,
        max_teilnehmer:           form.max_teilnehmer,
        anmeldegebuehr:           form.anmeldegebuehr,
        status:                   form.status,
        veroeffentlicht:          form.veroeffentlicht,
        altersklassen:            form.altersklassen,
        gewichtsklassen:          form.gewichtsklassen,
        regeln:                   form.regeln,
        hinweise:                 form.hinweise,
        kontakt_email:            form.kontakt_email,
        kontakt_telefon:          form.kontakt_telefon,
        website:                  form.website,
        default_tournament_mode:  form.default_tournament_mode,
        formen_scoring_mode:      form.formen_scoring_mode,
        bruchtest_scoring_mode:   form.bruchtest_scoring_mode,
        sv_scoring_mode:          form.sv_scoring_mode,
        preis_einzel:             form.preis_einzel,
        preis_team:               form.preis_team,
        rabatt_zweite_kategorie:  form.rabatt_zweite_kategorie,
        rabatt_weitere_kategorien:form.rabatt_weitere_kategorien,
        fruehbucher_bis:          form.fruehbucher_bis,
        fruehbucher_rabatt:       form.fruehbucher_rabatt,
        nachmeldegebuehr:         form.nachmeldegebuehr,
        nachmeldung_von_datum:    form.nachmeldung_von_datum,
        nachmeldung_von_uhrzeit:  form.nachmeldung_von_uhrzeit,
        nachmeldung_bis_datum:    form.nachmeldung_bis_datum,
        nachmeldung_bis_uhrzeit:  form.nachmeldung_bis_uhrzeit,
        bank_kontoinhaber:        form.bank_kontoinhaber,
        bank_iban:                form.bank_iban,
        bank_bic:                 form.bank_bic,
        bank_name:                form.bank_name,
        bank_verwendungszweck:    form.bank_verwendungszweck,
        altersberechnung_stichtag:form.altersberechnung_stichtag,
        altersberechnung_datum:   form.altersberechnung_datum,
        anmeldung_gewicht_pflicht:        form.anmeldung_gewicht_pflicht,
        anmeldung_graduierung_pflicht:    form.anmeldung_graduierung_pflicht,
        min_graduierung:          form.min_graduierung,
        max_teilnehmer_division:  form.max_teilnehmer_division,
      };

      const res    = await fetch(url, { method, headers: authHeader, body: JSON.stringify(payload) });
      if (!res.ok) {
        const errData = await res.json();
        const msg = errData.details?.length
          ? errData.details.join(' · ')
          : (errData.error || 'Fehler beim Speichern');
        throw new Error(msg);
      }

      const saved    = await res.json();
      const turnierId = saved.data?.turnier_id || id;

      if (turnierId) {
        await fetch(`/api/turniere/${turnierId}/kategorien`, {
          method: 'PUT',
          headers: authHeader,
          body: JSON.stringify({ kategorien: selectedKategorien }),
        });
        await uploadFiles(turnierId);
        await syncPerioden(turnierId);
      }

      setSuccess(isNew ? 'Turnier erstellt!' : 'Änderungen gespeichert!');
      setTimeout(() => navigate('/dashboard/turniere'), 1200);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="tbe-page">
        <div className="tbe-loading">
          <div className="tbe-spinner-lg"></div>
          <p>Turnier wird geladen…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tbe-page">

      {/* ── Header ── */}
      <div className="tbe-header">
        <div className="tbe-header-left">
          <span className="tbe-header-icon">{isNew ? '🏆' : '✏️'}</span>
          <div>
            <h1 className="tbe-header-title">
              {isNew ? 'Neues Turnier erstellen' : (form.name || 'Turnier bearbeiten')}
            </h1>
            <p className="tbe-header-sub">
              {isNew ? 'Alle Felder können später noch geändert werden' : 'Turnier bearbeiten'}
            </p>
          </div>
        </div>
        <div className="tbe-header-actions">
          <button className="tbe-btn tbe-btn--ghost" type="button" onClick={() => navigate('/dashboard/turniere')}>
            ← Zurück
          </button>
          <button
            className="tbe-btn tbe-btn--primary"
            type="submit"
            form="tbe-form"
            disabled={saving}
          >
            {saving ? <><span className="tbe-spinner-sm"></span> Speichern…</> : '💾 Speichern'}
          </button>
        </div>
      </div>

      {/* ── Messages ── */}
      {error   && <div className="tbe-msg tbe-msg--error">⚠ {error}</div>}
      {success && <div className="tbe-msg tbe-msg--success">✓ {success}</div>}

      {/* ── Tabs ── */}
      <div className="tbe-tabs">
        {TABS.map(tab => (
          <button
            key={tab.id}
            type="button"
            className={`tbe-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span>{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* ── Form ── */}
      <form id="tbe-form" onSubmit={handleSubmit} className="tbe-form">

        {/* ══ TAB: GRUNDDATEN ══ */}
        {activeTab === 'grunddaten' && (
          <div className="tbe-section">

            {/* Basisinfo */}
            <div className="tbe-card">
              <div className="tbe-card-title">Basisinformationen</div>
              <div className="tbe-grid">
                <div className="tbe-field tbe-field--full">
                  <label>Turniername <span className="tbe-req">*</span></label>
                  <input
                    type="text"
                    value={form.name}
                    onChange={e => set('name', e.target.value)}
                    placeholder="z. B. TDA Meisterschaft 2026"
                    required
                  />
                </div>
                <div className="tbe-field tbe-field--full">
                  <label>Beschreibung</label>
                  <textarea
                    rows={3}
                    value={form.beschreibung}
                    onChange={e => set('beschreibung', e.target.value)}
                    placeholder="Kurze Beschreibung des Turniers…"
                  />
                </div>
              </div>
            </div>

            {/* Status & Sichtbarkeit */}
            <div className="tbe-card">
              <div className="tbe-card-title">Status & Sichtbarkeit</div>
              <div className="tbe-grid">
                <div className="tbe-field">
                  <label>Status</label>
                  <div className="tbe-status-row">
                    {STATUS_OPTIONS.map(s => (
                      <button
                        key={s}
                        type="button"
                        className={`tbe-status-btn ${form.status === s ? 'active' : ''}`}
                        onClick={() => set('status', s)}
                      >
                        {s}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="tbe-field">
                  <label>Sichtbarkeit</label>
                  <button
                    type="button"
                    className={`tbe-publish-btn ${form.veroeffentlicht ? 'published' : ''}`}
                    onClick={() => set('veroeffentlicht', !form.veroeffentlicht)}
                  >
                    {form.veroeffentlicht ? '🌐 Veröffentlicht' : '🔒 Nicht veröffentlicht'}
                  </button>
                  <span className="tbe-hint">
                    {form.veroeffentlicht ? 'Turnier ist öffentlich sichtbar' : 'Nur intern sichtbar'}
                  </span>
                </div>
              </div>
            </div>

            {/* Disziplinen */}
            <div className="tbe-card">
              <div className="tbe-card-header">
                <div className="tbe-card-title">Disziplinen</div>
                <label className="tbe-check-all">
                  <input type="checkbox" checked={allDisziplinen} onChange={selectAllDisziplinen} />
                  <span>Alle</span>
                </label>
              </div>
              <div className="tbe-checkbox-grid tbe-checkbox-grid--3">
                {DISZIPLINEN.map(disc => (
                  <label key={disc} className="tbe-check-item">
                    <input
                      type="checkbox"
                      checked={disziplinList.includes(disc)}
                      onChange={() => toggleDisziplin(disc)}
                    />
                    <span>{disc}</span>
                  </label>
                ))}
              </div>
              {disziplinList.length > 0 && (
                <div className="tbe-count">{disziplinList.length} von {DISZIPLINEN.length} ausgewählt</div>
              )}
            </div>

            {/* Kategorien */}
            <div className="tbe-card">
              <div className="tbe-card-title">Turnier-Kategorien</div>
              <p className="tbe-hint" style={{ marginBottom: '1rem' }}>
                Welche Wettkampfkategorien werden angeboten?
              </p>
              <div className="tbe-checkbox-grid tbe-checkbox-grid--4">
                {KATEGORIEN.map(kat => (
                  <label
                    key={kat.id}
                    className={`tbe-check-item tbe-check-item--card ${selectedKategorien.includes(kat.id) ? 'selected' : ''}`}
                  >
                    <input
                      type="checkbox"
                      checked={selectedKategorien.includes(kat.id)}
                      onChange={() => toggleKategorie(kat.id)}
                    />
                    <span className="tbe-kat-icon">{kat.icon}</span>
                    <span>{kat.label}</span>
                  </label>
                ))}
              </div>
              {selectedKategorien.length > 0 && (
                <div className="tbe-count">{selectedKategorien.length} von {KATEGORIEN.length} ausgewählt</div>
              )}
            </div>

          </div>
        )}

        {/* ══ TAB: TERMIN & ORT ══ */}
        {activeTab === 'termin' && (
          <div className="tbe-section">

            <div className="tbe-card">
              <div className="tbe-card-title">Turnierdaten</div>
              <div className="tbe-grid">
                <div className="tbe-field">
                  <label>
                    Startdatum
                    {!form.datum_text && <span className="tbe-req"> *</span>}
                    <span style={{fontWeight:400,color:'#94a3b8',fontSize:'0.78rem',marginLeft:'0.4rem'}}>— entfällt bei Datumshinweis</span>
                  </label>
                  <input type="date" value={form.start_datum} onChange={e => set('start_datum', e.target.value)} />
                </div>
                <div className="tbe-field">
                  <label>
                    Datumshinweis
                    <span style={{fontWeight:400,color:'#94a3b8',fontSize:'0.78rem',marginLeft:'0.4rem'}}>z.B. „Herbst 2026"</span>
                  </label>
                  <input type="text" value={form.datum_text} onChange={e => set('datum_text', e.target.value)}
                    placeholder="Herbst 2026 / TBD / Frühjahr 2027" />
                </div>
                <div className="tbe-field">
                  <label>Enddatum</label>
                  <input type="date" value={form.end_datum} onChange={e => set('end_datum', e.target.value)} />
                </div>
                <div className="tbe-field">
                  <label>Anmeldeschluss</label>
                  <input type="date" value={form.anmeldeschluss} onChange={e => set('anmeldeschluss', e.target.value)} />
                </div>
              </div>
            </div>

            <div className="tbe-card">
              <div className="tbe-card-title">Veranstaltungsort</div>
              <div className="tbe-grid">
                <div className="tbe-field tbe-field--full">
                  <label>Halle / Venue</label>
                  <input type="text" value={form.ort} onChange={e => set('ort', e.target.value)} placeholder="z. B. Sporthalle Musterstadt" />
                </div>
                <div className="tbe-field tbe-field--full">
                  <label>Adresse</label>
                  <input type="text" value={form.adresse} onChange={e => set('adresse', e.target.value)} placeholder="Straße und Hausnummer" />
                </div>
                <div className="tbe-field">
                  <label>PLZ</label>
                  <input type="text" value={form.plz} onChange={e => set('plz', e.target.value)} placeholder="12345" />
                </div>
                <div className="tbe-field">
                  <label>Stadt</label>
                  <input type="text" value={form.stadt} onChange={e => set('stadt', e.target.value)} placeholder="Musterstadt" />
                </div>
                <div className="tbe-field">
                  <label>Land</label>
                  <input type="text" value={form.land} onChange={e => set('land', e.target.value)} placeholder="Deutschland" />
                </div>
              </div>
            </div>

          </div>
        )}

        {/* ══ TAB: PREISE ══ */}
        {activeTab === 'preise' && (() => {
          const base   = parseFloat(form.preis_einzel) || 0;
          const r2pct  = parseFloat(form.rabatt_zweite_kategorie)  || 0;
          const r3pct  = parseFloat(form.rabatt_weitere_kategorien) || 0;
          const frbpct = parseFloat(form.fruehbucher_rabatt) || 0;
          const r2euro  = base * r2pct  / 100;
          const r3euro  = base * r3pct  / 100;
          const frbeuro = base * frbpct / 100;

          const isEuro = discountMode === 'euro';

          const discountInputProps = (pctKey, euroVal) => isEuro ? {
            type: 'number', min: 0, step: 0.5, max: base || undefined,
            value: euroVal.toFixed(2),
            onChange: e => set(pctKey, base > 0 ? Math.min(100, parseFloat(e.target.value || 0) / base * 100) : 0)
          } : {
            type: 'number', min: 0, max: 100, step: 1,
            value: parseFloat(form[pctKey]) || 0,
            onChange: e => set(pctKey, e.target.value)
          };

          const discountHint = (pctVal, euroVal) => isEuro
            ? `= ${pctVal.toFixed(1)} %`
            : `= ${euroVal.toFixed(2)} €`;

          return (
          <div className="tbe-section">
            <div className="tbe-msg tbe-msg--info">
              💡 Bei mehreren Kategorien pro Person werden automatisch Staffelrabatte berechnet.
            </div>

            <div className="tbe-two-col">

              <div className="tbe-card">
                <div className="tbe-card-title">Grundpreise</div>
                <div className="tbe-grid">
                  <div className="tbe-field">
                    <label>Einzelkategorie (€)</label>
                    <input type="number" min="0" step="0.50" value={form.preis_einzel} onChange={e => set('preis_einzel', e.target.value)} />
                    <span className="tbe-hint">Basis für Kumite, Formen etc.</span>
                  </div>
                  <div className="tbe-field">
                    <label>Teamkategorie (€)</label>
                    <input type="number" min="0" step="0.50" value={form.preis_team} onChange={e => set('preis_team', e.target.value)} />
                    <span className="tbe-hint">Synchron-Formen, Team-Kumite</span>
                  </div>
                  <div className="tbe-field">
                    <label>Anmeldegebühr (€)</label>
                    <input type="number" min="0" step="0.01" value={form.anmeldegebuehr} onChange={e => set('anmeldegebuehr', e.target.value)} placeholder="0.00" />
                    <span className="tbe-hint">Allgemeine Bearbeitungsgebühr</span>
                  </div>
                </div>
              </div>

              <div className="tbe-card">
                <div className="tbe-card-header">
                  <div className="tbe-card-title">Staffelrabatte</div>
                  <div className="tbe-mode-toggle">
                    <button type="button" className={`tbe-mode-btn${!isEuro ? ' tbe-mode-btn--active' : ''}`} onClick={() => setDiscountMode('percent')}>%</button>
                    <button type="button" className={`tbe-mode-btn${isEuro ? ' tbe-mode-btn--active' : ''}`} onClick={() => setDiscountMode('euro')}>€</button>
                  </div>
                </div>
                <div className="tbe-grid">
                  <div className="tbe-field">
                    <label>Rabatt 2. Kategorie {isEuro ? '(€)' : '(%)'}</label>
                    <input {...discountInputProps('rabatt_zweite_kategorie', r2euro)} />
                    <span className="tbe-hint">{discountHint(r2pct, r2euro)}</span>
                  </div>
                  <div className="tbe-field">
                    <label>Rabatt 3.+ Kategorie {isEuro ? '(€)' : '(%)'}</label>
                    <input {...discountInputProps('rabatt_weitere_kategorien', r3euro)} />
                    <span className="tbe-hint">{discountHint(r3pct, r3euro)}</span>
                  </div>
                </div>
              </div>

              {/* Frühbucher-Zeiträume */}
              <div className="tbe-card tbe-card--full">
                <div className="tbe-card-header">
                  <div className="tbe-card-title">Frühbucher-Zeiträume</div>
                  <button type="button" className="tbe-btn-add" onClick={addPeriode}>+ Zeitraum</button>
                </div>
                <span className="tbe-hint" style={{ display: 'block', marginBottom: '0.5rem' }}>
                  Mehrere Perioden möglich, z.B. Mai–Jun 10 %, Jul–Aug 5 %.
                </span>
                {perioden.length === 0 && (
                  <div className="tbe-hint-empty">Noch keine Frühbucher-Zeiträume definiert.</div>
                )}
                {perioden.map((p) => (
                  <div className="tbe-periode-row" key={p._key}>
                    <input
                      type="text"
                      className="tbe-periode-bez"
                      placeholder="Bezeichnung"
                      value={p.bezeichnung || ''}
                      onChange={e => updatePeriode(p._key, 'bezeichnung', e.target.value)}
                    />
                    <input type="date" value={p.von_datum} onChange={e => updatePeriode(p._key, 'von_datum', e.target.value)} />
                    <input type="time" value={p.von_uhrzeit || '00:00'} onChange={e => updatePeriode(p._key, 'von_uhrzeit', e.target.value)} />
                    <span className="tbe-periode-sep">–</span>
                    <input type="date" value={p.bis_datum} onChange={e => updatePeriode(p._key, 'bis_datum', e.target.value)} />
                    <input type="time" value={p.bis_uhrzeit || '23:59'} onChange={e => updatePeriode(p._key, 'bis_uhrzeit', e.target.value)} />
                    <div className="tbe-periode-pct">
                      <input
                        type="number"
                        min="0"
                        max="100"
                        step="0.5"
                        placeholder="%"
                        value={p.rabatt_prozent || ''}
                        onChange={e => updatePeriode(p._key, 'rabatt_prozent', e.target.value)}
                      />
                      <span>%</span>
                    </div>
                    <button type="button" className="tbe-btn-icon tbe-btn-icon--del" onClick={() => removePeriode(p._key)}>✕</button>
                  </div>
                ))}
              </div>

              {/* Nachmeldung */}
              <div className="tbe-card tbe-card--full">
                <div className="tbe-card-title">Nachmeldung</div>
                <div className="tbe-grid">
                  <div className="tbe-field">
                    <label>Nachmeldegebühr (€)</label>
                    <input type="number" min="0" step="0.50" value={form.nachmeldegebuehr} onChange={e => set('nachmeldegebuehr', e.target.value)} />
                  </div>
                  <div className="tbe-field">
                    <label>Nachmeldung ab (Datum)</label>
                    <input type="date" value={form.nachmeldung_von_datum} onChange={e => set('nachmeldung_von_datum', e.target.value)} />
                  </div>
                  <div className="tbe-field">
                    <label>Nachmeldung ab (Uhrzeit)</label>
                    <input type="time" value={form.nachmeldung_von_uhrzeit} onChange={e => set('nachmeldung_von_uhrzeit', e.target.value)} />
                  </div>
                  <div className="tbe-field">
                    <label>Nachmeldung bis (Datum)</label>
                    <input type="date" value={form.nachmeldung_bis_datum} onChange={e => set('nachmeldung_bis_datum', e.target.value)} />
                  </div>
                  <div className="tbe-field">
                    <label>Nachmeldung bis (Uhrzeit)</label>
                    <input type="time" value={form.nachmeldung_bis_uhrzeit} onChange={e => set('nachmeldung_bis_uhrzeit', e.target.value)} />
                  </div>
                </div>
              </div>

              {/* Zahlungsinformationen */}
              <div className="tbe-card tbe-card--full">
                <div className="tbe-card-title">💳 Zahlungsinformationen <span className="tbe-card-title-sub">(optional — überschreibt globale Verbandsbankdaten auf Rechnungen)</span></div>
                <div className="tbe-grid">
                  <div className="tbe-field">
                    <label>Kontoinhaber</label>
                    <input type="text" value={form.bank_kontoinhaber} onChange={e => set('bank_kontoinhaber', e.target.value)} placeholder="z.B. TDA e.V." />
                  </div>
                  <div className="tbe-field">
                    <label>IBAN</label>
                    <input type="text" value={form.bank_iban} onChange={e => set('bank_iban', e.target.value)} placeholder="DE00 0000 0000 0000 0000 00" />
                  </div>
                  <div className="tbe-field">
                    <label>BIC</label>
                    <input type="text" value={form.bank_bic} onChange={e => set('bank_bic', e.target.value)} placeholder="XXXXXXXX" />
                  </div>
                  <div className="tbe-field">
                    <label>Bankname</label>
                    <input type="text" value={form.bank_name} onChange={e => set('bank_name', e.target.value)} placeholder="z.B. Volksbank Muster" />
                  </div>
                  <div className="tbe-field tbe-field--full">
                    <label>Verwendungszweck</label>
                    <input type="text" value={form.bank_verwendungszweck} onChange={e => set('bank_verwendungszweck', e.target.value)} placeholder="z.B. Startgebühr {Turniername} – {Kämpfername}" />
                  </div>
                </div>
              </div>

              <div className="tbe-card">
                <div className="tbe-card-title">Preisvorschau</div>
                <div className="tbe-price-preview">
                  <div className="tbe-price-row">
                    <span>1. Kategorie</span>
                    <strong>{base.toFixed(2)} €</strong>
                  </div>
                  <div className="tbe-price-row">
                    <span>2. Kategorie <em className="tbe-price-pct">−{r2pct.toFixed(0)} %</em></span>
                    <strong>{(base - r2euro).toFixed(2)} €</strong>
                  </div>
                  <div className="tbe-price-row">
                    <span>3.+ Kategorie <em className="tbe-price-pct">−{r3pct.toFixed(0)} %</em></span>
                    <strong>{(base - r3euro).toFixed(2)} €</strong>
                  </div>
                  {frbpct > 0 && (
                    <div className="tbe-price-row">
                      <span>mit Frühbucher <em className="tbe-price-pct">−{frbpct.toFixed(0)} %</em></span>
                      <strong>{(base - frbeuro).toFixed(2)} €</strong>
                    </div>
                  )}
                  <div className="tbe-price-row tbe-price-total">
                    <span>Gesamt (2 Kat.)</span>
                    <strong className="tbe-price-sum">
                      {(base + (base - r2euro)).toFixed(2)} €
                    </strong>
                  </div>
                </div>
              </div>

            </div>
          </div>
          );
        })()}

        {/* ══ TAB: CODES ══ */}
        {activeTab === 'codes' && (
          isNew
            ? <div className="tbe-section"><div className="tbe-msg tbe-msg--info">💡 Bitte Turnier erst speichern, bevor Rabattcodes vergeben werden.</div></div>
            : <RabattcodeTab turnierId={id} authHeader={authHeader} />
        )}

        {/* ══ TAB: DIVISIONEN ══ */}
        {activeTab === 'divisionen' && (
          isNew
            ? <div className="tbe-section"><div className="tbe-msg tbe-msg--info">💡 Bitte Turnier erst speichern, bevor Divisionen zugewiesen werden.</div></div>
            : <DivisionenTab turnierId={id} authHeader={authHeader} />
        )}

        {/* ══ TAB: EINSTELLUNGEN ══ */}
        {activeTab === 'einstellungen' && (
          <div className="tbe-section">

            <div className="tbe-grid tbe-grid--2">
              <ModeBox title="🥊 Kampf-Modus" sub="Kumite, Kickboxen, Grappling" modes={TOURNAMENT_MODES}
                name="default_tournament_mode" value={form.default_tournament_mode}
                onChange={v => set('default_tournament_mode', v)} />
              <ModeBox title="🎭 Formen-Modus" sub="Kata, Poomsae, Hyong" modes={FORMEN_MODES}
                name="formen_scoring_mode" value={form.formen_scoring_mode}
                onChange={v => set('formen_scoring_mode', v)} />
              <ModeBox title="🧱 Bruchtest-Modus" sub="Tameshiwari" modes={BRUCHTEST_MODES}
                name="bruchtest_scoring_mode" value={form.bruchtest_scoring_mode}
                onChange={v => set('bruchtest_scoring_mode', v)} />
              <ModeBox title="🛡️ SV-Modus" sub="Hosinsul, Selbstverteidigung" modes={SV_MODES}
                name="sv_scoring_mode" value={form.sv_scoring_mode}
                onChange={v => set('sv_scoring_mode', v)} />
            </div>

            <div className="tbe-card" style={{ marginTop: '1rem' }}>
              <div className="tbe-card-title">Regelwerk</div>
              <div className="tbe-grid">
                <div className="tbe-field">
                  <label>Altersklassen</label>
                  <input type="text" value={form.altersklassen} onChange={e => set('altersklassen', e.target.value)} placeholder="U12, U15, U18, Erwachsene" />
                </div>
                <div className="tbe-field">
                  <label>Gewichtsklassen</label>
                  <input type="text" value={form.gewichtsklassen} onChange={e => set('gewichtsklassen', e.target.value)} placeholder="-50kg, -60kg, +70kg" />
                </div>
                <div className="tbe-field tbe-field--full">
                  <label>Turnierregeln</label>
                  <textarea rows={4} value={form.regeln} onChange={e => set('regeln', e.target.value)} placeholder="Turnierregeln und besondere Bestimmungen…" />
                </div>
              </div>
            </div>

            {/* Altersberechnungs-Stichtag */}
            <div className="tbe-card" style={{ marginTop: '1rem' }}>
              <div className="tbe-card-title">🎂 Altersberechnungs-Stichtag</div>
              <div className="tbe-radio-group">
                <label className="tbe-radio-label">
                  <input type="radio" name="altersberechnung_stichtag" value="turniertag"
                    checked={form.altersberechnung_stichtag === 'turniertag'}
                    onChange={() => set('altersberechnung_stichtag', 'turniertag')} />
                  Turniertag (Standard)
                </label>
                <label className="tbe-radio-label">
                  <input type="radio" name="altersberechnung_stichtag" value="jahresende"
                    checked={form.altersberechnung_stichtag === 'jahresende'}
                    onChange={() => set('altersberechnung_stichtag', 'jahresende')} />
                  31. Dezember des Turnierjahres
                </label>
                <label className="tbe-radio-label">
                  <input type="radio" name="altersberechnung_stichtag" value="custom"
                    checked={form.altersberechnung_stichtag === 'custom'}
                    onChange={() => set('altersberechnung_stichtag', 'custom')} />
                  Festes Datum
                </label>
                {form.altersberechnung_stichtag === 'custom' && (
                  <input
                    type="date"
                    className="tbe-inline-date"
                    value={form.altersberechnung_datum}
                    onChange={e => set('altersberechnung_datum', e.target.value)}
                  />
                )}
              </div>
            </div>

            {/* Anmeldeeinstellungen */}
            <div className="tbe-card" style={{ marginTop: '1rem' }}>
              <div className="tbe-card-title">📋 Anmeldeeinstellungen</div>
              <div className="tbe-grid">
                <div className="tbe-field">
                  <label className="tbe-checkbox-label">
                    <input type="checkbox" checked={form.anmeldung_gewicht_pflicht} onChange={e => set('anmeldung_gewicht_pflicht', e.target.checked)} />
                    Gewicht ist Pflichtfeld bei Anmeldung
                  </label>
                </div>
                <div className="tbe-field">
                  <label className="tbe-checkbox-label">
                    <input type="checkbox" checked={form.anmeldung_graduierung_pflicht} onChange={e => set('anmeldung_graduierung_pflicht', e.target.checked)} />
                    Graduierung ist Pflichtfeld bei Anmeldung
                  </label>
                </div>
                <div className="tbe-field">
                  <label>Mindest-Graduierung</label>
                  <input type="text" value={form.min_graduierung} onChange={e => set('min_graduierung', e.target.value)} placeholder="z.B. 6. Kyu, Gelb-Grün" />
                </div>
                <div className="tbe-field">
                  <label>Max. Teilnehmer (gesamt)</label>
                  <input type="number" min="1" value={form.max_teilnehmer} onChange={e => set('max_teilnehmer', e.target.value)} placeholder="Unbegrenzt" />
                </div>
                <div className="tbe-field">
                  <label>Max. Teilnehmer pro Division</label>
                  <input type="number" min="1" value={form.max_teilnehmer_division} onChange={e => set('max_teilnehmer_division', e.target.value)} placeholder="Unbegrenzt" />
                </div>
              </div>
            </div>

          </div>
        )}

        {/* ══ TAB: MEDIEN ══ */}
        {activeTab === 'medien' && (
          <div className="tbe-section">
            <div className="tbe-two-col">

              {/* Logo */}
              <div className="tbe-card">
                <div className="tbe-card-title">Turnier-Logo</div>
                <p className="tbe-hint" style={{ marginBottom: '1rem' }}>
                  Vereins- oder Turnierlogo. Empfohlen: quadratisch, min. 300×300 px (PNG/JPG)
                </p>
                <div className="tbe-upload-area">
                  <input
                    type="file"
                    accept="image/png,image/jpeg,image/webp,image/svg+xml"
                    onChange={e => handleFileChange('logo', e.target.files[0])}
                  />
                  {logoPreview ? (
                    <>
                      <img src={logoPreview} alt="Logo Vorschau" className="tbe-upload-preview tbe-upload-preview--logo" />
                      <div className="tbe-hint">Klicken um zu ändern</div>
                    </>
                  ) : (
                    <>
                      <div className="tbe-upload-icon">🏅</div>
                      <span className="tbe-upload-label">Logo hochladen</span>
                      <span className="tbe-upload-hint-text">PNG, JPG, SVG — max. 5 MB</span>
                    </>
                  )}
                </div>
                {logoPreview && (
                  <button type="button" className="tbe-upload-remove" onClick={() => { setLogoPreview(null); setLogoFile(null); }}>
                    ✕ Entfernen
                  </button>
                )}
              </div>

              {/* Plakat */}
              <div className="tbe-card">
                <div className="tbe-card-title">Plakat / Poster</div>
                <p className="tbe-hint" style={{ marginBottom: '1rem' }}>
                  Turnierplakat oder Ausschreibung. Empfohlen: A4 Hochformat, min. 794×1123 px (PNG/JPG/PDF)
                </p>
                <div className="tbe-upload-area">
                  <input
                    type="file"
                    accept="image/png,image/jpeg,image/webp,application/pdf"
                    onChange={e => handleFileChange('plakat', e.target.files[0])}
                  />
                  {plakatPreview ? (
                    <>
                      <img src={plakatPreview} alt="Plakat Vorschau" className="tbe-upload-preview" />
                      <div className="tbe-hint">Klicken um zu ändern</div>
                    </>
                  ) : (
                    <>
                      <div className="tbe-upload-icon">🪧</div>
                      <span className="tbe-upload-label">Plakat hochladen</span>
                      <span className="tbe-upload-hint-text">PNG, JPG, PDF — max. 10 MB</span>
                    </>
                  )}
                </div>
                {plakatPreview && (
                  <button type="button" className="tbe-upload-remove" onClick={() => { setPlakatPreview(null); setPlakatFile(null); }}>
                    ✕ Entfernen
                  </button>
                )}
              </div>

            </div>

            {/* Banner — volle Breite */}
            <div className="tbe-card" style={{ marginTop: '1.5rem' }}>
              <div className="tbe-card-title">Header-Banner</div>
              <p className="tbe-hint" style={{ marginBottom: '1rem' }}>
                Wird oben auf der Turnierdetailseite als großes Headerbild angezeigt. Empfohlen: Querformat 1920×480 px (PNG/JPG/WebP)
              </p>
              <div className="tbe-upload-area tbe-upload-area--banner">
                <input
                  type="file"
                  accept="image/png,image/jpeg,image/webp"
                  onChange={e => handleFileChange('banner', e.target.files[0])}
                />
                {bannerPreview ? (
                  <>
                    <img src={bannerPreview} alt="Banner Vorschau" className="tbe-upload-preview tbe-upload-preview--banner" />
                    <div className="tbe-hint">Klicken um zu ändern</div>
                  </>
                ) : (
                  <>
                    <div className="tbe-upload-icon">🖼️</div>
                    <span className="tbe-upload-label">Banner hochladen</span>
                    <span className="tbe-upload-hint-text">PNG, JPG, WebP — empfohlen 1920×480 px — max. 10 MB</span>
                  </>
                )}
              </div>
              {bannerPreview && (
                <button type="button" className="tbe-upload-remove" onClick={() => { setBannerPreview(null); setBannerFile(null); }}>
                  ✕ Entfernen
                </button>
              )}
            </div>

            <div className="tbe-msg tbe-msg--info">
              ℹ️ Dateien werden beim Klick auf „Speichern" zusammen mit den anderen Daten hochgeladen.
            </div>
          </div>
        )}

        {/* ══ TAB: KONTAKT ══ */}
        {activeTab === 'kontakt' && (
          <div className="tbe-section">
            <div className="tbe-two-col">
              <div className="tbe-card">
                <div className="tbe-card-title">Kontaktdaten</div>
                <div className="tbe-grid">
                  <div className="tbe-field">
                    <label>E-Mail</label>
                    <input type="email" value={form.kontakt_email} onChange={e => set('kontakt_email', e.target.value)} placeholder="turnier@example.com" />
                  </div>
                  <div className="tbe-field">
                    <label>Telefon</label>
                    <input type="tel" value={form.kontakt_telefon} onChange={e => set('kontakt_telefon', e.target.value)} placeholder="+49 123 456789" />
                  </div>
                  <div className="tbe-field tbe-field--full">
                    <label>Website</label>
                    <input type="url" value={form.website} onChange={e => set('website', e.target.value)} placeholder="https://turnier.example.com" />
                  </div>
                </div>
              </div>
              <div className="tbe-card">
                <div className="tbe-card-title">Hinweise für Teilnehmer</div>
                <div className="tbe-field">
                  <textarea rows={6} value={form.hinweise} onChange={e => set('hinweise', e.target.value)} placeholder="Weitere Hinweise, Parkinformation, Dresscode…" />
                </div>
              </div>
            </div>
          </div>
        )}

      </form>
    </div>
  );
}

// ── Sub-Komponente: ModeBox ──
function ModeBox({ title, sub, modes, name, value, onChange }) {
  return (
    <div className="tbe-card">
      <div className="tbe-card-title">{title}</div>
      <p className="tbe-hint" style={{ marginBottom: '0.75rem' }}>{sub}</p>
      <div className="tbe-mode-list">
        {modes.map(m => (
          <label key={m.value} className={`tbe-mode-option ${value === m.value ? 'selected' : ''}`}>
            <input type="radio" name={name} value={m.value} checked={value === m.value} onChange={() => onChange(m.value)} />
            <div>
              <div className="tbe-mode-label">{m.label}</div>
              <div className="tbe-mode-desc">{m.description}</div>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}
